"use client"
import { Routes, Route, Navigate } from "react-router-dom"
import Sidebar from "./Sidebar"
import Header from "./Header"
import CenterPage from "./pages/CenterPage"
import WebUserManagement from "./pages/WebUserManagement"
import CustomerSearch from "./pages/CustomerSearch"
import CustomerDetails from "./pages/CustomerDetails"
import SummaryReport from "./pages/SummaryReport"
import WorkroomPhoneNumbers from "./pages/WorkroomPhoneNumbers"
import EmergencyAfterHours from "./pages/EmergencyAfterHours"
import RegionalManagers from "./pages/RegionalManagers"
import Forms from "./pages/Forms"

export default function Dashboard() {
  return (
    <div className="h-screen flex bg-gray-100">
      {/* Sidebar controls its own width */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />

        <main className="flex-1 overflow-y-auto bg-white">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard/center" />} />
            <Route path="/center" element={<CenterPage />} />
            <Route path="/web-users" element={<WebUserManagement />} />
            <Route path="/customer-search" element={<CustomerSearch />} />
            <Route path="/customer-details/:customerId" element={<CustomerDetails />} />
            <Route path="/summary-report" element={<SummaryReport />} />
            <Route path="/workroom-phone-numbers" element={<WorkroomPhoneNumbers />} />
            <Route path="/emergency-after-hours" element={<EmergencyAfterHours />} />
            <Route path="/regional-managers" element={<RegionalManagers />} />
            <Route path="/forms" element={<Forms />} />
          </Routes>
        </main>
      </div>

      {/* Right Info Panel - Optional */}
      {/* <div className="w-[8%] min-w-[120px] bg-white shadow-lg border-l">
        <InfoPanel />
      </div> */}
    </div>
  )
}
